<template>
  <div>
  <div style="overflow: hidden;padding: 10px 0px 20px 0px;position:relative;" class="markin-markout-slider-wrapper">
    <div class="image-loading" v-show="isSliderLoading" style="width: 100%;height: 96px;">
         <div>
           <img :src="loadingGif"/>
        </div>
    </div>
    <div v-show="isSliderLoaded" style="position:relative;">
      <div class="story-board-slider-wrapper" ref="sliderMainWrapperRef">
        <VueRangeSlider  class="storyboard-markin-markout-slider" style="height:unset;" v-on:click.native="seekSliderToCurrentClickPos($event)" :clickable="false" :dot-attrs="getDotsAttr()"  :marks="currentTimeUpdateMark" @hook:mounted="sliderMounted" :step="250" ref="slider" @drag-end="handleDraggingChange"  v-model="value" v-bind="options" :enableCross="false" @change="sliding">
          <template>
              <div style="display:flex;justify-content: flex-start;">
                  <ul style="height: 100%; width:100%; list-style: none; display: flex; padding: 0; margin: 0;">
                    <li v-for="(url, index) in storyBoardList" class="storyboard-image-wrapper-list" :key="index" style="width: 10%; display: flex; list-style: none; justify-content: center; aspect-ratio: 4 / 3;"><img class="storyboard-image" style="width: 100%; height: 100%; display: block; margin: 0; object-fit: cover;" draggable="false" :src="getStoryBoardProxyConvertedURL(url)" @error="replaceByDefaultImage"/></li>
                  </ul>
              </div>
          </template>

    <!--       <template v-slot> 
             <div>
                <VueRangeSlider  @hook:mounted="cursorSliderMounted" :dot-attrs="{ 'cursor-slider-dot': 'cursor' }" class="cursor-move-on-storyboard-slider" ref="cursorSlider" v-bind="options" :tooltip-placement="'top'" :tooltip="'always'">
                </VueRangeSlider>
             </div>
          </template> -->
          <template v-slot:mark>
            <div class="cursor-as-custom-mark" style="height:0;width:100%;">
                <!-- <div class="fusion-seek-cursor" style="width:100%;height:0;">
                    <input type="range" style="height:0;" @input="handleCursorInput" @click="handleSliderClick($event)" ref="timelinecursorRef" class="timeline-cursor-slider-element" name="range" min="0" :max="options.max" />
                    <label for="range">0</label>
                </div> -->
                <div class="range-slider" ref="cursorRangeSliderContainer">
                <div class="slider-container" ref="cursorSliderContainer">
                    <div class="slider-track" ref="cursorSliderTrack"></div>
                    <div class="slider-thumb-handle" ref="cursorSliderThumbHandle">
                        <svg width="8" fill="#cc9f0f" xmlns="http://www.w3.org/2000/svg" style="z-index:1">
                          <path style="fill:#cc9f0f" d="M 5.351 0 L 1.784 0 C 0.799 0 0 0.895 0 2 L 0 12.2 C 0 12.7 0.178 13.2 0.535 13.6 L 2.319 15.6 C 3.032 16.4 4.103 16.4 4.816 15.6 L 6.6 13.6 C 6.957 13.2 7.135 12.7 7.135 12.2 L 7.135 2 C 7.135 0.895 6.337 0 5.351 0 Z" fill="#ddd"/>
                        </svg>
                    </div>
                    <div class="slider-thumb" ref="cursorSliderThumb">
                      <div class="slider-tooltip" ref="sliderTooltipHandle">{{getDurationWithFrames(cursorSliderValue)}}</div>
                    </div>
                  </div>
                  <!-- <div class="slider-value" ref="cursorSliderValue"></div> -->
                </div>
            </div>
          </template>
        </VueRangeSlider>
      </div>
    </div>
  </div>
     <slot name="action_buttons" :range="value" ref="action_btn_ref"></slot>
  </div>
</template>

<script>
import VueRangeSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import {mapActions,mapMutations} from 'vuex';
import brokenThumbnailImg from "@/assets/video-file-1281615872381304.png";
import Utils from "../../components.utils.js";
import {NotifierConstants} from '../../components.constants.js'
export default {
   name:'RangeSlider',
   components:{VueRangeSlider},
   props:{
     playerDuration:{
        type: Number,
        default: 0,
     },
     assetDetails:{
       type: Object,
       default: function(){
         return {};
       }
     }
   },
   data() {
    return {
    //  playerDuration:46,
     value: [],
     options: {
        // data:[0,46],
        min:0,
        max:parseInt(this.playerDuration),
        enableCross:true,
      },
      storyBoardList:[],
      loadingGif:Utils.getLoadingGif(),
      isSliderLoading:true,
      isSliderLoaded:false,
      resizeObservor:null,
      playerDurationInMillisecond:0,
      frameRate:25,
      MILLI_SECOND:1000,
      currentTimeUpdateMark:{0: ''},
      cursorSliderValue:0,
      cursorResizableObservor:null,
      debouncedOnChange:null,
      timeIntervalPX: 1
    }
  },
  created() {
    this.min = 0
    this.max = null;
    this.enableCross = false;
   
    if(this.assetDetails && this.assetDetails.frame_rate)
       this.frameRate = this.assetDetails.frame_rate;


    this.debouncedOnChange = this.debounce(this.cursorSliding,250);

    this.registerforWebsocketNotifications();
  },
  methods:{
    getStoryBoardProxyConvertedURL(url){
      return Utils.convertToLoginIPDomainName(url);
    },
    handleDraggingChange(index){
       console.log("[handleDraggingChange handleDraggingChange]",index);
       if(index == 0){
          this.$emit("captureINframe",this.$refs.slider.getValue()[index],Number(this.$refs.slider.getValue()[index] / this.MILLI_SECOND));
       }

       if(index == 1){
          this.$emit("markoutValueHasChanged",this.$refs.slider.getValue()[index]);
       }
    },
    seekSliderToCurrentClickPos(event){
      const sliderRailRect = this.$refs.slider.$el.getBoundingClientRect();
      const position = (event.clientX - sliderRailRect.left) / sliderRailRect.width;
      console.log(`position position`,position);
      console.log(this.$refs.slider.getPosByEvent(event));
    },
    getDotsAttr(){
        return { 'main-slider-dot': 'main' };
    },
    setPositionFromValue(value) {
        const percentage = ((value - this.options.min) / (this.options.max - this.options.min)) * 100;
        //const position = ((this.$refs.cursorSliderContainer.offsetWidth - this.$refs.cursorSliderThumb.offsetWidth) / 100) * percentage;
        const position = parseInt(
          ((this.$refs.cursorSliderContainer.offsetWidth - this.$refs.cursorSliderThumb.offsetWidth) / 100) * percentage
        );
        this.$refs.cursorSliderTrack.style.width = `${parseInt(position + this.$refs.cursorSliderThumb.offsetWidth / 2)}px`;
        this.$refs.cursorSliderThumb.style.left = `${position}px`;
        this.$refs.cursorSliderThumbHandle.style.left = `${position}px`;
        // this.$refs.cursorSliderValue.style.left = `${position}px`;
        // this.$refs.cursorSliderValue.innerHTML = this.getDurationWithHHMMSSFFformat(value);
        this.cursorSliderValue = parseInt(value);
     },
     moveThumb(e) {
        let position = e.clientX - this.$refs.cursorSliderContainer.getBoundingClientRect().left;
        if (position < 0) {
          position = 0;//this.$refs.cursorSliderThumb.offsetWidth / 2;
        } else if (position > this.$refs.cursorSliderContainer.offsetWidth - this.$refs.cursorSliderThumb.offsetWidth / 2) {
          position = this.$refs.cursorSliderContainer.offsetWidth - this.$refs.cursorSliderThumb.offsetWidth / 2;
        }
        let percentage = (position / (this.$refs.cursorSliderContainer.offsetWidth - this.$refs.cursorSliderThumb.offsetWidth)) * 100;
        if(percentage > 100){
          percentage = 100;
        }
        const value = ((this.options.max - this.options.min) / 100) * percentage + this.options.min;
        // console.log(`value.......`,value,`e.clientY`,e.clientY);
        // this.$refs.cursorSliderValue.style.cssText += `visibility: visible;`;
        // console.log(`visibility: visible;top:${e.clientY}px !important;`);
        this.setPositionFromValue(value);
        this.debouncedOnChange(value);
     },
    setToolTipHandlePosition (event) {
        if(!event) return;
        this.$refs.sliderTooltipHandle.style.cssText += 'visibility:visible;'
        this.$refs.sliderTooltipHandle.style.top = `${(event.offsetY - this.$refs.sliderTooltipHandle.clientHeight) - 10 }px`;
        if(event.offsetY <= 32){
          this.$refs.sliderTooltipHandle.style.top = '5px';
          return;
        }
     },
     handleSliderClick(event){
        console.log('event',event);
        event.preventDefault();
     },
     debounce(func, delay) {
      let timeoutId;
      return function() {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          func.apply(this, arguments);
        }, delay);
      };
    },
    handleCursorInput(e){
      const scale = (num, in_min, in_max, out_min, out_max) => {
          return ((num - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
      }
      const value = +e.target.value;
      console.log('value.....',value);
      this.debouncedOnChange(value);
      const label = e.target.nextElementSibling;
      const rangeWidth = getComputedStyle(e.target).getPropertyValue("width");
      const labelWidth = getComputedStyle(label).getPropertyValue("width");
      // remove px
      const numWidth = +rangeWidth.substring(0, rangeWidth.length - 2);
      console.log('numWidth',numWidth);
      const numLabelWidth = +labelWidth.substring(0, labelWidth.length - 2);
      const max = +e.target.max;
      const min = +e.target.min;
      const left =
        value * (numWidth / max) -
        numLabelWidth / 2 +
        scale(value, min, max, 10, -10);
      label.style.left = `${left}px`;
      label.innerHTML = value;
    },
    setFrameRate(assetObj){
        if(assetObj && Object.prototype.hasOwnProperty.call(assetObj,'frame_rate')){
            this.frameRate = assetObj.frame_rate;
        }
    },

    replaceByDefaultImage(e){
      e.target.onerror = null;
      if(this.assetDetails.proxy_info && this.assetDetails.proxy_info.thumbnail_uri && this.assetDetails.proxy_info.thumbnail_uri.length > 0){
        e.target.src = Utils.convertToLoginIPDomainName(this.assetDetails.proxy_info.thumbnail_uri);
      }else{
        e.target.src = Utils.getNoThumbnailImg();
      }
    },
     
     getRightmostSliderClass(){
           const sliderElement = this.$refs.slider.$el;
            setTimeout(() => {
                let sliderFullWidth = sliderElement.getBoundingClientRect().width;
                let sliderCrossedWidth = sliderElement.querySelector('.vue-slider-dot:nth-child(even)').getBoundingClientRect().left;
                let crossedwidth = sliderFullWidth - sliderCrossedWidth;
                if(crossedwidth <= 197) { 
                  sliderElement.querySelector('.custom-tooltip').classList.add('move-marker-to-left');
                }
                else
                sliderElement.querySelector('.custom-tooltip').classList.remove('move-marker-to-left');
            },300);
     },

     getRelativePositionValue(value,index){
       let type = (index == 0) ? 'odd' : 'even';
       let paddingType = (index == 0) ? 'paddingLeft' : 'paddingRight';
       let pos = this.$refs.slider.$el.querySelector(`.vue-slider-dot:nth-child(${type})`).getBoundingClientRect();
       let compObj = window.getComputedStyle(this.$refs.slider.$el);
       let padding = parseFloat(compObj[paddingType]);
       let finalPos;
       if(index == 0){
          finalPos =  (pos.left - padding) - (pos.width + 1) ;
       }else{
          finalPos =  (pos.right - padding) + (pos.width - 2);
       }
       return finalPos;
     },

     sliding(steps,index){
        this.$emit('steps',Number(steps[index] / this.MILLI_SECOND));
        try{
           this.setPositionFromValue(steps[index]);
        }catch(e){console.log(e)}
        if(index == 1){
          this.$attrs.markinMarkoutRef.markinMarkoutActionRef.markoutDurationValue = Utils.getDurationBasedOnVideoDuration(steps[index] / this.MILLI_SECOND,this.playerDuration,this.frameRate,'.');
          this.$attrs.markinMarkoutRef.markinMarkoutActionRef.markoutPlaceholderValue = this.$attrs.markinMarkoutRef.markinMarkoutActionRef.markoutDurationValue;
          if(!this.$attrs.markinMarkoutRef.markinMarkoutActionRef.markinDurationValue){
              this.$attrs.markinMarkoutRef.markinMarkoutActionRef.markinDurationValue = Utils.getDurationBasedOnVideoDuration(0,this.playerDuration,this.frameRate,'.');
          }
        }
        if(index == 0){
          this.$attrs.markinMarkoutRef.markinMarkoutActionRef.markinDurationValue = Utils.getDurationBasedOnVideoDuration(steps[index] / this.MILLI_SECOND,this.playerDuration,this.frameRate,'.');
        }
    },
    cursorSliding(steps){
        this.$emit('steps',Number(steps / this.MILLI_SECOND));
    },
    getDistribution(){
      let  res = [];

      for(let i = 0; i <= Math.floor(this.playerDuration) * 10; i++){
         res.push(i/10);
      }
       
      return res;

    },

    formatMarkinMarkoutTooltip(){
      return this.getDurationWithFrames(this.value[0]) + ' - '+ this.getDurationWithFrames(this.value[1]); 
    },   


    getDurationWithFrames(duration){
        return Utils.getExactDuationInSeconds(duration / this.MILLI_SECOND,this.frameRate,'.');
    }, 

    getDurationWithHHMMSSFFformat(duration){
       return Utils.getExactDuationInSeconds(duration / this.MILLI_SECOND,this.frameRate, '.');
    },

    getDurationInSeconds(duration){
      let min = 0, sec = 0, hrs = 0;
        if(duration){
            hrs = duration / 3600;
            var rem = duration % 3600;
            min = rem / 60;
            sec = rem % 60;
        }
        
        hrs = Math.floor(hrs);
        min = Math.floor(min);
        sec = Math.floor(sec);
        
        if(hrs >=0 && hrs <= 9) {
            hrs = "0"+hrs;
        }
        if(min >=0 && min <= 9) {
            min = "0"+min;
        }
        if(sec >=0 && sec <= 9) {
            sec = "0"+sec;
        }

        return hrs+":"+min+":"+sec;
    },
    getComponentByName(name){
       if(!name) return {};
       let foundComp = this;
       while(foundComp){
            foundComp = foundComp.$parent;
        if(!foundComp) break;
        if(foundComp && foundComp['$options']['_componentTag'] == name) break;
       }
       return foundComp;
    },
    getBrokenStoryboard(){
        let storyBoardUrl = [];
        for(let i = 1; i <= 10; i++){
          if(this.assetDetails.proxy_info && this.assetDetails.proxy_info.thumbnail_uri && this.assetDetails.proxy_info.thumbnail_uri.length > 0){
            storyBoardUrl.push(
              Utils.convertToLoginIPDomainName(this.assetDetails.proxy_info.thumbnail_uri)
            );
          }else{
            storyBoardUrl.push(brokenThumbnailImg);
          }
        }
        return storyBoardUrl;
    },
    buildStoryBoard(storyBoardBaseUri){
     if(storyBoardBaseUri && !(storyBoardBaseUri.lastIndexOf('/') == (storyBoardBaseUri.length - 1))) storyBoardBaseUri = storyBoardBaseUri + '/';
      console.log('storyBoardBaseUri storyBoardBaseUri',storyBoardBaseUri);

      this.getStoryboardFromServer(storyBoardBaseUri).then(storyBoardList =>{
          console.log('storyBoardList',storyBoardList);
          storyBoardList = storyBoardList.map(storyBoardObj => {
              return `${storyBoardBaseUri}/${storyBoardObj.name}`
          });
          console.log('storyBoardList',storyBoardList);
          if(storyBoardList && Array.isArray(storyBoardList) && storyBoardList.length == 0)
              storyBoardList = this.getBrokenStoryboard();
          this.storyBoardList = storyBoardList;
      }).catch(error => {
          console.log(error);
          this.storyBoardList = this.getBrokenStoryboard();
      });
    },
   handleProxyUpdatedNotification(notification){
       let data = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
       console.log('[handleProxyUpdatedNotification]',data);
        if(data.message && Object.hasOwnProperty.call(data.message,'path') && data.message.path === this.assetDetails.path){
           this.buildStoryBoard(data.message.proxy_info.storyboard_uri);
        }
    },
    registerforWebsocketNotifications(){
        this.addWSEventListener({
            eventname:[NotifierConstants.proxyUpdatedNotification],
            callback:this.handleProxyUpdatedNotification,
            parent:"subclips"})
    }, 
    getStartEndTime(){
      return {start:Utils.getBoundingOrNearestFrame(this.value[0]),end:Utils.getBoundingOrNearestFrame(this.value[1])}
    },
    cursorSliderMounted(){
      const sliderElement = this.$refs.cursorSlider.$el;
      setTimeout(()=>{
        let prefixWithClass = ['.vue-slider-process','.vue-slider-dot','.vue-slider-rail'];
        prefixWithClass.forEach(el => {
            [].forEach.call(sliderElement.querySelectorAll(el), (ell) =>{
                ell.classList.remove('main-slider');
            })
        });
      },1200);
    },
    sliderMounted(){
      const sliderElement = this.$refs.slider.$el;
      this.isSliderLoading = false;
      this.isSliderLoaded = true;
      this.resizeObservor = new ResizeObserver(() =>{
          let width = window.getComputedStyle(sliderElement, null).getPropertyValue('width');
          width = Number(String(width).replace('px',''));
          this.timeIntervalPX = this.options.max / width;
          let height = ((width / 4) / 10) * 3; // set height as per 4:3 aspect ratio
          console.log('calculated height',height,'width width',width);
          sliderElement.style.cssText = `height:${height}px !important`;

          this.$refs.cursorSliderThumb.style.cssText += `height:${height + 20}px !important;`

          this.resizeObservor.disconnect();
          try{
              let allToolTipNodeList = sliderElement.querySelectorAll('.vue-slider-dot-tooltip');
              let arr = Array.from(allToolTipNodeList);
              arr = arr.splice(1,arr.length)
              arr.forEach(el => el.style.cssText += 'visibility:hidden !important;'); // hide all other tooltips except 1st one
          }catch(e){
              console.log(e);
          }
      });
      this.resizeObservor.observe(sliderElement);
      sliderElement.style.cssText = `height:unset !important`;
     },
    initializeMarkers(){
      let playerDuration = this.playerDurationInMillisecond;
      this.$nextTick(() => {
        this.options.max = playerDuration;//Math.floor(Math.round(playerDuration));
        this.value.length = 0;
        this.value.push(0);
        this.value.push(playerDuration);

      });
    },
    removeListeners() {
      document.removeEventListener('mousemove', this.moveThumb);
      document.removeEventListener('mouseup', this.removeListeners);
      setTimeout(()=>{
         this.$refs.sliderTooltipHandle.style.cssText += 'visibility: hidden;';
      },30);
    },
    handleClickOnSliderRail(event){
      console.log(`event.........`,event);
      [].forEach.call(this.$refs.slider.$el.querySelectorAll('.vue-slider-dot-handle'),(el)=>{
        el.classList.add('show-slider-handle-always');
      })
    },
    ...mapMutations("websocket",["addWSEventListener","removeWSEventListener"]),
    ...mapActions('proxy',['getStoryboardFromServer'])
  },
  mounted(){
     this.playerDurationInMillisecond = parseInt(this.playerDuration * this.MILLI_SECOND);
     this.$nextTick(() => {
         this.options.max = this.playerDurationInMillisecond;
         this.value.push(0);
         this.value.push(this.playerDurationInMillisecond);
     });

     let storyBoardBaseUri = '';
     try{
       if(!this.assetDetails && !Object.hasOwnProperty.call(this.assetDetails,'proxy_info')){
          let parentComp = this.getComponentByName(this.$parent.$attrs.wrappercomponent);
          storyBoardBaseUri = parentComp.assetDetails.proxy_info.storyboard_uri;
       }
     }catch(e){console.log(e);}
     try{
        storyBoardBaseUri = this.assetDetails.proxy_info.storyboard_uri;
     }catch(e){console.log(e)}
     this.buildStoryBoard(storyBoardBaseUri);


     this.$refs.cursorSliderThumb.addEventListener('mousedown', (e) => {
      e.preventDefault();
      this.setToolTipHandlePosition(e);
      document.addEventListener('mousemove', this.moveThumb);
      document.addEventListener('mouseup', this.removeListeners);
    });

    this.$refs.cursorSliderThumbHandle.addEventListener('mousedown', (e) => {
      e.preventDefault();
      this.setToolTipHandlePosition(e);
      document.addEventListener('mousemove', this.moveThumb);
      document.addEventListener('mouseup', this.removeListeners);
    });

    this.$nextTick(() => {
       const sliderRail = this.$refs.slider.$el.querySelector('.vue-slider-rail');
       sliderRail.addEventListener('click', this.handleClickOnSliderRail);
    });

  },
  beforeDestroy(){
     this.resizeObservor.disconnect();
     this.removeWSEventListener({
        eventname:[NotifierConstants.proxyUpdatedNotification],
        callback:this.handleProxyUpdatedNotification,
        parent:"subclips"});

      const sliderRail = this.$refs.slider.$el.querySelector('.vue-slider-rail');
      // remove click event listener from slider rail
      sliderRail.removeEventListener('click', this.handleClickOnSliderRail);
  },
  watch:{
    immediate:true,
    playerDuration: function(playerDuration){
      try{
         this.setFrameRate(this.assetDetails);
       }catch(e){console.log(e)}
       console.log('playerDuration',playerDuration, this.playerDuration);
      //  this.playerDurationInMillisecond = parseInt(playerDuration);
       this.playerDurationInMillisecond = parseInt(playerDuration * this.MILLI_SECOND);
       this.$nextTick(() => {
          this.initializeMarkers();
       });
    },
    'assetDetails.file_uid': function(){
      try{
       this.setFrameRate(this.assetDetails);
      }catch(e){console.log(e)}
       let storyBoardBaseUri = this.assetDetails.proxy_info.storyboard_uri;
       this.buildStoryBoard(storyBoardBaseUri);
    }
  }
}
</script>

<style lang="scss" scoped>

 $slider-bg-color: #d9ae24;
 $cursorTimelineColor: #d5d2d2;
 $sliderHoldingHandleColor: #d5d2d2;

 ::v-deep{
   
  .vue-slider-dot-handle{
       box-shadow: none !important;
       background-color: transparent !important;
  }

 .storyboard-markin-markout-slider.vue-slider{
     margin-top: 16px;
     padding: 7px 21px !important;
 }

.storyboard-markin-markout-slider .vue-slider-dot{
    height: 100% !important;
    height: calc(100% + 3px) !important;
    width: 10px !important;
    background: $slider-bg-color;
    transform: translate(-50%,-49%) !important;
    cursor: col-resize;
}

.storyboard-markin-markout-slider .vue-slider-dot:nth-child(odd){
    border-bottom-left-radius: 4px;
    border-top-left-radius: 4px;
    margin-inline-start: 4px;
 }

 .storyboard-markin-markout-slider .vue-slider-dot:nth-child(even){
    border-bottom-right-radius: 4px;
    border-top-right-radius: 4px;
    margin-inline-start: -4px;
 }

 .storyboard-markin-markout-slider .vue-slider-dot:before{
    width: 2px;
    content: "";
    background: rgba(0, 0, 0, 0.5);
    border-radius: 2px;
    top: 23%;
    position: absolute;
    inset-inline-start: 50%;
    min-height: 34%;
    transform: translate(-50%, 29%);
}

.storyboard-markin-markout-slider .vue-slider-dot:hover{
    z-index: 999;
}

.storyboard-markin-markout-slider .vue-slider-process{
  border-radius: 6px !important;
  background-color: transparent;
  border-top: 1px solid $slider-bg-color;
  border-bottom: 1px solid $slider-bg-color;
}

.storyboard-markin-markout-slider .vue-slider-dot .vue-slider-dot-handle:active{
  cursor: col-resize !important;
}

.storyboard-markin-markout-slider .vue-slider-dot:nth-child(odd) .vue-slider-dot-tooltip-top{
  top: 201px !important;
  transform: translate(-51%, -100%) rotate(179deg);
}

.storyboard-markin-markout-slider .vue-slider-dot:nth-child(odd) + div{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.storyboard-markin-markout-slider .vue-slider-dot:nth-child(odd) + div > li{
    height: 100%;
    display: flex;
    list-style: none;
    justify-content: center;
}

.storyboard-markin-markout-slider .vue-slider-dot:nth-child(odd) + div > li img{
   width:100%;
   height:100%;
}

.storyboard-markin-markout-slider .vue-slider-rail{
  background: transparent !important;
  max-height: inherit;
}
.storyboard-markin-markout-slider .vue-slider-process:before{
    content: '';
    display: block;
    width: 100%;
    height: 116%;
    opacity: 1;
    box-shadow: 0vmax 0vmin 0 2000vmin #080808b5;
    z-index: 1;
    position: absolute;
    top: -4px;
}

.storyboard-markin-markout-slider .vue-slider-dot .vue-slider-dot-tooltip-bottom {
    bottom: -2px !important;
    inset-inline-start: 25% !important;
    -webkit-transform: translate(-50%,100%) !important;
    transform: translate(-125%,100%) !important;
}

.storyboard-markin-markout-slider .vue-slider-dot .vue-slider-dot-tooltip-top {
   top: -15px !important;
   transform: translate(17px,-35%) !important;
}
.storyboard-markin-markout-slider .vue-slider-rail{
    border-radius: 0 !important;
}


.cursor-move-on-storyboard-slider{
  height: unset !important; 
  padding: 0 !important;
}

.cursor-move-on-storyboard-slider .vue-slider-rail{
    background: transparent !important;
}

.cursor-move-on-storyboard-slider .vue-slider-process{
    background: transparent !important;
}

.cursor-move-on-storyboard-slider .vue-slider-dot[cursor-slider-dot="cursor"] .vue-slider-dot-handle{
    width: 3px;
    background: red;
    box-shadow: none;
    border-radius: 0;
}


.vue-slider-marks{
    position: absolute;
    z-index: 9999;
    height: 0;
  .vue-slider-mark{
      height: 100%;
      .vue-slider-mark-step{
          height: 100%;
      }

      .vue-slider-mark-label{
          width: 3px;
          background: red;
          height: 126%;
          position: relative;
          bottom: 0;
          top: -3px;
          margin: 0;
      }

      .vue-slider-mark-label:before {
          background: url('data:image/svg+xml;utf8,<svg width="8" height="17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 0H2a2 2 0 00-2 2v10.2c0 .5.2 1 .6 1.4l2 2c.8.8 2 .8 2.8 0l2-2c.4-.4.6-.9.6-1.4V2a2 2 0 00-2-2z" fill="red"/></svg>') no-repeat center center;
          position: absolute;
          top: -17px;
          content: "";
          inset-inline-start: -9px;
          width: 20px;
          height: 17px;
          background-size: 13px 20px;
      }
  }
 }

 .cursor-as-custom-mark{
     height: 100%;
     .vue-slider-dot{
       height: 160% !important;
     }
     .vue-slider-dot:before{
          background: url('data:image/svg+xml;utf8,<svg width="8" height="17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 0H2a2 2 0 00-2 2v10.2c0 .5.2 1 .6 1.4l2 2c.8.8 2 .8 2.8 0l2-2c.4-.4.6-.9.6-1.4V2a2 2 0 00-2-2z" fill="red"/></svg>') no-repeat center center;
          position: absolute;
          top: -17px;
          content: "";
          inset-inline-start: -9px;
          width: 20px;
          height: 17px;
          background-size: 13px 20px;
     }
     .vue-slider-dot-tooltip{
        top: 36px !important;
        inset-inline-start: 11% !important;
     }
     .vue-slider-dot-tooltip-inner{
        border-color: #bc0a46!important;
        background-color: #d30f52!important;
       padding: 5px 20px !important;
     }
 }

 .fusion-seek-cursor {
    position: relative;

    input[type="range"] {
      width: 100%;
      margin: 18px 0;
      -webkit-appearance: none;
    }
    
    input[type="range"]:focus {
      outline: none !important;
      box-shadow: none !important;
      background: transparent !important;
      border: 0 !important;
    }
    
    input[type="range"] + label {
      background-color: #fff;
      position: absolute;
      top: -25px;
      inset-inline-start: 110px;
      width: 80px;
      padding: 5px 0;
      text-align: center;
      border-radius: 4px;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
    }
    
    /* Chrome & Safari */
    input[type="range"]::-webkit-slider-runnable-track {
      background: transparent;
      border-radius: 4px;
      width: 100%;
      height: 10px;
      cursor: pointer;
    }
    
    input[type="range"]::-webkit-slider-thumb {
      -webkit-appearance: none;
      height: 24px;
      width: 3px;
      background: red;
    }
    
    /* Firefox */
    input[type="range"]::-moz-range-track {
      background: transparent;
      border-radius: 4px;
      width: 100%;
      height: 14px;
      cursor: pointer;
    }
    
    input[type="range"]::-moz-range-thumb {
      -webkit-appearance: none;
      height: 24px;
      width: 24px;
      background: #fff;
      border-radius: 50%;
      border: 1px solid purple;
      margin-top: -7px;
      cursor: pointer;
    }
    
    /* IE */
    input[type="range"]::-ms-track {
      background: purple;
      border-radius: 4px;
      width: 100%;
      height: 14px;
      cursor: pointer;
    }
    
    input[type="range"]::-ms-thumb {
      -webkit-appearance: none;
      height: 24px;
      width: 24px;
      background: #fff;
      border-radius: 50%;
      border: 1px solid purple;
      margin-top: -7px;
      cursor: pointer;
    }
  }

}

.image-loading{
  position: absolute;
    width: 100%;
    height: 96px;
    max-height: 96px;
    z-index: 9999999;
    top: 50%;
    background: #000;
    transform: translateY(-50%);
}
.image-loading img{
   height: 100%;
    width: 119px;
    text-align: center;
    position: absolute;
    inset-inline-start: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}
.move-marker-to-left{
    position: relative;
    inset-inline-start: -195px;
}

.range-slider {
  position: relative;
  width: 100%;
  // height: 20px;
  z-index:99;
}

.slider-container {
  position: absolute;
  top: -75%;
  inset-inline-start: 0;
  // transform: translateY(-50%);
  width: 100%;
  height: 0;
  background-color: #ddd;
}

.slider-track {
  position: absolute;
  top: 0;
  inset-inline-start: 0;
  height: 0;
  background-color: transparent !important;
}

.slider-thumb,.slider-thumb-handle {
  position: relative;
  top: -18px;
  inset-inline-start: 0;
  width: 3px;
  background-color: $slider-bg-color;
  cursor: move;
  // display: inline-block;
  will-change: transform;
}

.slider-thumb{
   position: absolute !important;
   top: -1px !important;
}

.slider-thumb-handle{
    display: inline-block;
    position: relative;
    top: -19px;
    cursor: grabbing;
    svg{
      z-index: 1;
      position: absolute;
      top: -16px;
      inset-inline-start: 50%;
      transform: translate(calc(-63% + 1px));
      height: 19px;
    }
}

.slider-value {
    position: absolute;
    font-size: 11px;
    background: #e11818;
    display: flex;
    padding: 3px 9px;
    transform: translateX(-49%);
    z-index: 0;
    border-radius: 12px;
    visibility: hidden;
    min-width: 45px !important;
    display: flex;
    justify-content: center;
}

.slider-value:before {
    content: "";
    position: absolute;
    inset-inline-start: 37.899%;
    bottom: -17px;
    width: 16px;
    background: #e63d31;
    height: 12px;
    transform: translateY(-50%);
    clip-path: polygon(100% 0, 0 0, 50% 100%);
}

.slider-thumb:active + .slider-value,
.slider-thumb:focus + .slider-value{
   visibility: visible;
}

.slider-tooltip {
    position: absolute;
    font-size: 11px;
    background: #ededed;
    padding: 3px 9px;
    transform: translateX(-51%);
    z-index: 0;
    border-radius: 12px;
    min-width: 45px !important;
    display: flex;
    justify-content: center;
    inset-inline-start: 50%;
    color: #333;
    top: 9px;
    visibility: hidden;
}
.slider-tooltip:before {
    content: "";
    position: absolute;
    inset-inline-start: 50%;
    bottom: -10px;
    width: 16px;
    background: #ededed;
    height: 7px;
    transform: translate(-50%,-50%);
    -webkit-clip-path: polygon(100% 0, 0 0, 50% 100%);
    clip-path: polygon(100% 0, 0 0, 50% 100%);
    z-index: -1;
}


</style>